import React from "react";
import { Redirect } from "react-router-dom";

const AdminRedirect = () => <Redirect to={window.location.pathname.slice(6, window.location.pathname.length) + window.location.search} />

export default AdminRedirect